export default __webpack_public_path__ + "static/media/0xc004e2318722ea2b15499d6375905d75ee5390b8.0ace3bb2.png";